import React from "react";
import { FaFileExport } from "react-icons/fa";

export default function Export(props) {

  return (
    <>
      <div className="icon-button">
        <FaFileExport/>
      </div>
    </>
  );
}
